const datePickerOptions = {
  enableTime: true,
  dateFormat: "DD/MM/YYYY HH:mm",
  placeholder: "dd/mm/yyyy hh:mm",
};

export const uiSchemaFnc = ({ t, rtwAtMin }) => {
  return {
    startsAt: {
      "ui:widget": "date-picker",
      "ui:options": {
        ...datePickerOptions,
        // minDate: absenceStartAtMin,
      },
      "ui:title": t("ABSENCE_START_DATE"),
    },
    rtwAt: {
      "ui:widget": "date-picker",
      "ui:options": {
        ...datePickerOptions,
        minDate: rtwAtMin,
      },
      "ui:title": t("RETURN_TO_WORK_DATE_AND_TIME"),
    },
  };
};
